var React = require('react');

function ChevronDown (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M10,13.889 L10,13.889 L8.586,12.475 L8.586,12.475 L3.636,7.525 L5.05,6.111 L10,11.061 L14.95,6.111 L16.364,7.525 L10,13.889 z"})));
}

ChevronDown.defaultProps = {"version":"1.1","x":"0","y":"0","viewBox":"0, 0, 20, 20"};

module.exports = ChevronDown;

ChevronDown.default = ChevronDown;
